import { render, staticRenderFns } from "./InlexzoFullFooter.vue?vue&type=template&id=16b1dcc4&scoped=true&"
import script from "./InlexzoFullFooter.vue?vue&type=script&lang=ts&"
export * from "./InlexzoFullFooter.vue?vue&type=script&lang=ts&"
import style0 from "./InlexzoFullFooter.vue?vue&type=style&index=0&id=16b1dcc4&lang=scss&scoped=true&"
import style1 from "./InlexzoFullFooter.vue?vue&type=style&index=1&id=16b1dcc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1dcc4",
  null
  
)

export default component.exports